import {
    initializeClubManagement,
} from '../../plugins/ClubManagement/assets/js/index.js';

import {
    initializeGameAdmin,
} from '../../plugins/GameAdmin/assets/js/index.js';

import {
    initializePublicPortal,
} from '../../plugins/PublicPortal/assets/js/index.js';

const initializePluginComponents = (root = document) => {
    initializePublicPortal(root);
    initializeClubManagement(root);
    initializeGameAdmin(root);
};

export {
    initializePluginComponents,
};
